(ns common.schema.entities.holding.core
  (:require [common.roles :as roles]
            [common.schema.entities.holding.schema :as holding]))

(defn- disable-permissions-check-fn
  [{:keys [tr role entity has-write-permissions?]}]
  (cond
    (not (or (roles/admin? role)
             (has-write-permissions? entity)))
    (tr :not-allowed)

    (->> entity
         :exit-opportunity/_target-holding
         (remove :common/disabled?)
         (seq))
    (tr :cannot-delete-holding-when-target-in-exit-oppo)))

(def entity-type-definition
  {:entity-type                  :entity.type/holding
   :schema                       holding/schema
   :name                         {:en "Holding"}
   :plural                       {:en "Holdings"}
   :icon                         :fa-briefcase
   :create-icon                  :fa-briefcase
   :read-permissions-check-fn    (fn [{:keys [account-current-permissions]}]
                                   (contains? (:account-modules account-current-permissions)
                                              :module/portfolio))
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; Explicitly false: holding's dedicated OpenSearch index already exists
   ;; and is populated via the legacy common.opensearch.entity-indices
   ;; mechanism, not the newer :entity/search-index?-driven
   ;; backend.search.dedicated.indexes/init! path - this key would otherwise
   ;; default to true just because :search is present below.
   :search-index?                false

   :search                       {:result/title-attr    :holding/name
                                  :list/default-columns [:holding/name
                                                         :holding/cur-paid-in-capital
                                                         :holding/cur-distributions
                                                         :holding/cur-residual-value
                                                         :holding/owner]
                                  :views                {:grid {:po-default-field-paths [[:holding/name]
                                                                                         [:holding/cur-paid-in-capital]
                                                                                         [:holding/cur-distributions]
                                                                                         [:holding/cur-residual-value]
                                                                                         [:holding/owner]]
                                                                :mandatory-field-paths  [[:holding/name]]}}}})
